import { Controller } from '@hotwired/stimulus';
import { ref, watch } from '@vue/reactivity';
import { clamp } from '../utilities/clamp';

export default class extends Controller {
  static targets = ['input', 'priceOutput', 'minWarning'];

  static values = {
    basePrice: Number,
    includedSeats: {
      type: Number,
      default: 0,
    },
  };

  get min() {
    return parseInt(this.inputTarget.min, 10);
  }

  get total() {
    return this.totalRef;
  }

  connect() {
    this.seats = ref(parseInt(this.inputTarget.value, 10));
    this.totalRef = ref(0);
    this.element.setAttribute('data-reactive-value', 'true');
    this.element.reactiveValue = this.totalRef;
    watch(
      this.seats,
      (newSeats) => {
        this.inputTarget.value = newSeats;
        this.totalRef.value = Math.max(newSeats - this.includedSeatsValue, 0) * this.basePriceValue;
        this.minWarningTarget.classList.toggle('hidden', newSeats > this.min);
      },
      { immediate: true },
    );
    watch(
      this.totalRef,
      (newTotal) => {
        this.priceOutputTarget.innerHTML = newTotal;
      },
      { immediate: true },
    );
    this.inputTarget.addEventListener('change', () => this.seats.value = clamp(this.inputTarget.value, this.min, 9999));
  }

  addSeat(event) {
    if (event) {
      event.preventDefault();
    }
    this.seats.value = clamp(this.seats.value + 1, this.inputTarget.min, 9999);
  }

  removeSeat(event) {
    if (event) {
      event.preventDefault();
    }
    this.seats.value = clamp(this.seats.value - 1, this.inputTarget.min, 9999);
  }
}
